import { useGetImprovementProposal } from "@/api/console/improvement-proposals/useGetImprovementProposal";
import LoadingScreen from "@/components/Loading";
import { Button } from "@/components/ui/button";
import download from "@/lib/download";
import { handlePrintPdf } from "@/lib/handlePrintPdf";
import ImprovementProposalResult from "@/src/_components/ImprovementProposalResult/ImprovementProposalResult";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

function ImprovementProposalResultPage() {
  const navigate = useNavigate();
  const { id = "" } = useParams();
  const { data, isLoading } = useGetImprovementProposal(id);
  const { t } = useTranslation();
  const [isPrinting, setPrinting] = useState(false);
  const [isDownloading, setDownloading] = useState(false);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!data) {
    navigate("/console/all-assessments");
    return null;
  }

  return (
    <div className="h-full overflow-auto">
      <div className="flex justify-between px-16 py-4 border-b border-cool-gray-200">
        <span className="text-2xl font-bold">{t("assessment-result")}</span>
        <div>
          <Button
            isLoading={isPrinting}
            variant="outline"
            onClick={() => {
              setPrinting(true);
              handlePrintPdf(
                "improvement-proposal",
                "improvement-proposal",
                () => {
                  setPrinting(false);
                },
              );
            }}
          >
            {t("download-proposal")}
          </Button>
          <Button
            disabled={isDownloading}
            onClick={async () => {
              setDownloading(true);
              await download(
                `/console/improvement_proposals/${id}/download`,
              ).then(() => {
                setDownloading(false);
              });
            }}
          >
            {t("download-excel")}
          </Button>
        </div>
      </div>
      <ImprovementProposalResult improvementProposal={data.data} />
    </div>
  );
}

export default ImprovementProposalResultPage;
